import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';
import Helper from '@lovata/popup-helper';
import ProductCardHelper from '../../common/helper/product-card-helper';

export default new class ProductCardQuickAdd {
  constructor() {
    this.obShopaholicCartAdd = new ShopaholicCartAdd();
    this.productCardHelper = new ProductCardHelper();

    // Modal windows
    this.drawerNavSelector = 'quick-add__wrapper';
    this.drawerBtnSelector = 'js-add-cart-modal';
    this.preLoaderSelector = 'popup-add-cart__preloader';
    this.drawerOpenNavSelector = 'quick-add__wrapper_visible';
    this.drawerProductPanel = 'quick-add-product__panel';
    this.isLoad = false;

    // Tooltip
    this.tooltipSelector = 'quick-add__tooltip';
    this.tooltipVisibleSelector = 'quick-add__tooltip_visible';
    this.messageClearDelay = 2000;

    // Form add cart
    this.formClass = 'quick-add__form';
    this.idProductSelector = 'data-product-id';
    this.addCartBtnSelector = '_shopaholic-cart-add';
    this.quantityBtn = '_quantity-btn';
    this.errorSelect = 'Необходимо выбрать размер';

    this.mediaQueryList = window.matchMedia('(max-width: 769px)');

    if (this.mediaQueryList.matches) {
      this.sMiniCartWrapper = '_shopaholic-cart-mini-mobile-wrapper';
    } else {
      this.sMiniCartWrapper = '_shopaholic-cart-mini-wrapper';
    }

    this.isPage = document.body.getAttribute('data-page-id');

    this.init();
  }

  init() {
    if ((this.isPage === 'catalog')
      || (this.isPage === 'tags')
      || (this.isPage === 'search')) {
      this.load();
    }
  }

  load() {
    const div = document.createElement('div');
    const body = document.querySelector('body');
    div.classList.add(this.drawerNavSelector);
    body.append(div);

    $.request('onAjax', {
      update: {
        'product/product-card/product-card-quick-add': `.${this.drawerNavSelector}`,
      },
      complete: () => {
        this.handler();
        this.initAddCart();
        this.updateQuantity();
      },
    });
  }

  handler() {
    $(document)
      .ready(() => {
        const modal = document.querySelector(`.${this.drawerNavSelector}`);
        $(document)
          .on('click', `.${this.drawerBtnSelector}`, (e) => {
            this.togglePopup(e, modal);
          });
      });
  }

  togglePopup(eventObject, popup) {
    eventObject.preventDefault();

    const { currentTarget } = eventObject;
    const isOpen = $(popup)
      .hasClass(this.drawerOpenNavSelector);

    Helper.setBodyScrollState(isOpen);
    Helper.overlayHandler(!isOpen, currentTarget, popup);

    const productId = eventObject.currentTarget.getAttribute(this.idProductSelector);

    if (!this.isLoad) {
      this.loadPopupContent(isOpen, productId);
    }

    this.clearPanel(isOpen);

    $(popup)
      .toggleClass(this.drawerOpenNavSelector);
  }

  loadPopupContent(isOpen, productId) {
    if (isOpen) return;

    $.request('onAjax', {
      data: {
        product_id: productId,
      },
      update: {
        'product/product-card/product-card-quick-add-ajax': `.${this.drawerProductPanel}`,
      },
      loading: `.${this.preLoaderSelector}`,
      success: function (res) { // eslint-disable-line object-shorthand, func-names
        this.isLoad = true;
        this.success(res);
      },
    });
  }

  clearPanel(isOpen) {
    if (!isOpen) return;

    const panelWrapper = $(`.${this.drawerProductPanel}`);

    const childrenNode = panelWrapper.children();

    if (!childrenNode.length) return;

    childrenNode.remove();
  }

  initAddCart() {
    $('body')
      .on('click', `.${this.addCartBtnSelector}`, () => {
        if (!this.productCardHelper.checkSelectOffer()) {
          this.showTooltip(this.errorSelect, false);
          return;
        }

        this.obShopaholicCartAdd.setAjaxRequestCallback((obRequestData, obButton) => {
          /* eslint-disable  no-param-reassign */
          obRequestData.update = {
            'product/cart/cart-mini/cart-info/cart-info': `.${this.sMiniCartWrapper}`,
          };
          obRequestData.complete = ({ responseJSON }) => {
            this.obShopaholicCartAdd.completeCallback(responseJSON, obButton);
            this.showTooltip('Товар добавлен в корзину', true);
          };
          /* eslint-enable */

          return obRequestData;
        })
          .init();
      });
  }

  updateQuantity() {
    this.productCardHelper.initUpdateQuantity();
    this.productCardHelper.initUpdateButton();
  }

  showTooltip(message, status) {
    const tooltip = $(`.${this.tooltipSelector}`);

    if (!status) {
      tooltip.addClass('tooltip__error');
    } else {
      tooltip.removeClass('tooltip__error');
    }

    tooltip.addClass(this.tooltipVisibleSelector)
      .text(message);

    this.timer = setTimeout(() => {
      this.hideTooltip();
    }, this.messageClearDelay);
  }

  hideTooltip() {
    const tooltip = $(`.${this.tooltipSelector}`);
    tooltip.removeClass(this.tooltipVisibleSelector)
      .text('');
  }
}();
